<template>
  <div v-if="isShow">
    <a href="https://www.iichi.com/app" :class="$style.banner" @click="onClick">
      <span :class="$style.logo"><IichiLogoSvg width="34" /></span>
      <span :class="$style.text">iichi公式アプリ<br />アプリ限定クーポン配布中！</span>
      <span :class="$style.download">ダウンロード</span>
      <button type="button" :class="$style.close" aria-label="バナーを閉じる" @click.prevent="onClose">×</button>
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';
import { useCommonStore } from '@/js/lib/store/common';
import IichiLogoSvg from '@/svgs/vue/iichi-logo.svg';

const KEY = 'close-app-download-banner';
const commonStore = useCommonStore();
const isShow = ref(!getFromStorage({ key: KEY }) && !commonStore.isWebView);
const onClick = () => {
  window.dataLayer?.push({
    event: 'app_banner_click',
  });
};
const onClose = () => {
  isShow.value = false;
  setToStorage({ key: KEY, value: true, expirationSeconds: -1 });
};
</script>

<style module lang="scss">
.banner {
  align-items: center;
  background-color: #ededed;
  display: grid;
  gap: 4px;
  grid-template-areas: 'close logo text download';
  justify-content: space-between;
  padding: 10px 12px 10px 0;

  @media (--pc) {
    display: none;
  }
}

.logo {
  align-items: center;
  background-color: var(--color-white);
  border-radius: 10px;
  display: flex;
  grid-area: logo;
  height: 56px;
  justify-content: center;
  width: 56px;
}

.text {
  font-size: 12px;
  font-weight: bold;
  grid-area: text;
  line-height: 1.4;
  padding: 0 4px;
}

.download {
  background-color: var(--color-white);
  border: 1px solid var(--color-black);
  border-radius: 6px;
  font-size: 13px;
  font-weight: bold;
  grid-area: download;
  padding: 4px 11px;
}

.close {
  align-self: stretch;
  font-size: 18px;
  grid-area: close;
  padding: 0 6px;
}
</style>
